<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-01 11:54:11
 * @LastEditors: knx-xc
--> 
<template>
  <div class="category">
    <div class="nav ">
      <ul class="container-body">
        <li :class="index == activeCategroyIndex ? 'active' : '' " v-for="(item,index) of categroyList" :key="index" v-text="item.name" @click="onCategroyClick(index)"> </li>
      </ul>
    </div>
    <Bread :breads="[{ name:'首页',path:'index'} ,{name:'贴心健康',path:'intimate'},{name:categroyList[activeCategroyIndex]['name'],path:'' }]"></Bread>

    <div class="category-content container-body">
      <div class="category-title" v-show="categroyList.length > 0">
        <div class="left">
          <img :src="categroyList[activeCategroyIndex]['image']" alt="暂无信息">
        </div>
        <div class="right">
          <div>
            <h1 v-text="categroyList[activeCategroyIndex]['name']"></h1>
            <h6 v-text="categroyList[activeCategroyIndex]['mainIntroduction']"></h6>
          </div>
          <!-- 服务 -->
          <!-- <ul class="service">
            <li v-for="(item,index) of service" :key="index">
              <img :src="item.image" alt="">
              <p v-text="item.name"> </p>
            </li>
          </ul> -->
        </div>
      </div>
      <div class="product-list">
        <div class="product-item" v-for="(el,index) of productList" :key="index">
          <div class="img-box">
            <img :src="el.image" alt="">
            <div class="qr">
              <img src="../../../assets/images/intimate/xcx.jpg" alt="">
              <p v-text="'微信扫码立即购买'"></p>
            </div>
          </div>
          <div class="info">
            <h2 v-text="el.name"> </h2>
            <h3>
              <span class="price" v-text="'￥ '+el.price"></span>
              <span v-if="el.linePrice != 0 && el.linePrice" class="line-price" v-text="'￥ '+el.linePrice"></span>
            </h3>
          </div>
        </div>
        <div class="more">
          <h1 v-text="'更多优惠'"> </h1>
          <img src="../../../assets/images/intimate/xcx.jpg" alt="">
          <h3 v-text="'尽在贴心健康商城'"></h3>
        </div>
        <div class="temp"> </div>
        <div class="temp"> </div>
        <div class="temp"> </div>
        <div class="temp"> </div>
      </div>
    </div>

  </div>
</template>
 
<script>
import { intimate_topicslist, intimate_productlist, } from "../../../request/api.user/all"
export default {
  name: '',
  data() {
    return {
      categroyList: [{ name: "" }],
      activeCategroyIndex: 0,
      service: [
        {
          image: require("../../../assets/images/intimate/s_1.png"),
          name: "假一赔十"
        },
        {
          image: require("../../../assets/images/intimate/s_2.png"),
          name: "48小时内发货"
        }
      ],
      productList: []
    }
  },
  created() {
    this.getCategroy();
  },
  mounted() {

  },
  methods: {
    //获取类目
    getCategroy() {
      const _this = this;
      intimate_topicslist().then(res => {
        // console.log('获取类目', res.data);
        if (res.code === 0 && res.data.length > 0) {
          this.categroyList = res.data;
          let id = this.$route.query.id || sessionStorage.getItem('cate_id');
          this.getCategroyProduct(id);
          this.categroyList.filter((item, index) => {
            if (item.id == id) {
              _this.activeCategroyIndex = index;
            }
          })
        }

      })
    },
    // 获取类目商品
    getCategroyProduct(id) {
      intimate_productlist({ id: id }).then(res => {
        // console.log('获取类目商品', res.data)
        if (res.code === 0) {
          this.productList = res.data
        }
      })
    },
    onCategroyClick(index) {
      if (this.activeCategroyIndex == index) return
      this.activeCategroyIndex = index;
      let id = this.categroyList[index]['id']
      sessionStorage.setItem('cate_id',id );
      this.getCategroyProduct(id)

    }

  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
.category {
  // background: #fafafa;
}
/* 分类*/
.nav {
  padding: 0 20px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  font-size: 20px;
  font-weight: bold;
  background: #124990;
  ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    li {
      padding-right: 80px;
      cursor: pointer;
      color: #ffffff;
      opacity: 0.5;
    }
    li.active {
      opacity: 1;
    }
  }
}

.category-content {
  // padding: 0 200px;
  .category-title {
    width: 100%;
    display: flex;
    align-items: stretch;
    .left {
      width: 590px;
      height: 320px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      flex: 1;
      padding-left: 30px;
      color: #666666;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #ffffff;
      h1 {
        margin-top: 44px;
        font-size: 40px;
        font-weight: bold;
        line-height: 52px;
      }
      h6 {
        margin-top: 30px;
        font-size: 16px;
        line-height: 21px;
      }
      .service {
        display: flex;
        align-items: center;
        margin-bottom: 36px;
        li {
          text-align: center;
          img {
            width: 86px;
            height: 86px;
          }
          p {
            margin-top: 30px;
            color: #666666;
            font-size: 16px;
          }
        }
        li:not(:first-child) {
          margin-left: 67px;
        }
      }
    }
  }
  .product-list {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-around;
    // justify-content: flex-start;
    padding-bottom: 50px;
    .product-item {
      width: 278px;
      padding: 24px;
      // margin-right: 30px;
      background: #ffffff;
      box-sizing: border-box;
      margin-bottom: 30px;
      .img-box {
        position: relative;
        width: 230px;
        height: 230px;
        img {
          width: 100%;
          height: 100%;
        }
        .qr {
          position: absolute;
          top: 0px;
          left: 0px;
          bottom: 0px;
          right: 0px;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          // opacity: 0;
          display: none;
          img {
            width: 155px;
            height: 155px;
          }
          p {
            margin-top: 9px;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
          }
        }
      }
      .img-box:hover .qr {
        display: block;
        display: flex;
        // opacity: 1;
      }
      .info {
        h2 {
          margin-top: 23px;
          font-size: 16px;
          color: #666666;
          line-height: 21px;
          text-align: left;
        }
        h3 {
          margin-top: 24px;
          display: flex;
          justify-content: space-around;
          align-content: center;
          font-size: 18px;
          line-height: 24px;
          font-weight: bold;

          span {
            display: inline-block;
          }
          .line-price {
            text-decoration: line-through;
            color: #999999;
          }
        }
      }
    }
    .more {
      width: 278px;
      background: #124990;
      color: #ffffff;
      text-align: center;
      align-self: flex-start;
      margin-bottom: 30px;
      h1 {
        margin-top: 27px;
        font-size: 40px;
        font-weight: bold;
        line-height: 52px;
      }
      img {
        margin-top: 15px;
        width: 236px;
        height: 236px;
      }
      h3 {
        margin: 23px 0;
        font-size: 20px;
      }
    }
    .temp {
      width: 278px;
      height: 0;
      margin-bottom: 0;
      border: none;
      padding: 0;
    }
  }
}
</style>